module.exports = __webpack_public_path__ + "media/images/icons/outlined/select-ff025b2f2b6eca10789b3d64598122aa.svg";